<template>
  <BGModal :shown="dialogShown"
           :title="$t('admin_sasv.edit_title')">
    <template #content>
      <v-container class="add-user" v-if="sasv">
        <v-form ref="sasvForm">
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_sasv.octopus_no')"
                            :value="sasv.octopus_no"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <!--          <v-row>-->
          <!--            <v-col>-->
          <!--              <v-text-field readonly-->
          <!--                            :label="$t('admin_sasv.name')"-->
          <!--                            :value="sasv.name"-->
          <!--                            hide-details="auto"></v-text-field>-->
          <!--            </v-col>-->
          <!--          </v-row>-->
          <v-row>
            <v-col>
              <v-text-field :outlined="sasv.status === 'APPROVED'"
                            :readonly="sasv.status !== 'APPROVED'"
                            :label="$t('admin_sasv.surname')"
                            v-model="sasv.surname"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field :outlined="sasv.status === 'APPROVED'"
                            :readonly="sasv.status !== 'APPROVED'"
                            :label="$t('admin_sasv.given_name')"
                            v-model="sasv.given_name"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_sasv.company')"
                            :value="sasv.company ? sasv.company.name : 'N/A'"
                            hide-details="auto"
                            v-if="sasv.status !== 'APPROVED'"></v-text-field>
              <v-autocomplete outlined
                              :label="$t('admin_sasv.company')"
                              :placeholder="$t('admin_sasv.company')"
                              :items="companyOptions"
                              v-model="selectedCompanyId"
                              v-if="sasv.status === 'APPROVED'">
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_sasv.source')"
                            :value="$t(`sasv_source.${sasv.source}`)"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_sasv.id_type')"
                            :value="$t(`id_type.${sasv.id_type}`)"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-expansion-panels accordion>
                <v-expansion-panel>
                  <v-expansion-panel-header>{{ $t('admin_sasv.id') }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col>
                        <v-input>
                          <v-container fluid class="flex-column pa-0">
                            <legend class="v-label theme--light">{{ $t('admin_sasv.octopus_front') }}</legend>
                            <v-img contain
                                   :src="getURL(sasv.octopus_front)"
                                   max-height="300px"
                                   @click="showImage(0)"></v-img>
                          </v-container>
                        </v-input>
                      </v-col>
                      <v-col>
                        <v-input>
                          <v-container fluid class="flex-column pa-0">
                            <legend class="v-label theme--light">{{ $t('admin_sasv.octopus_back') }}</legend>
                            <v-img contain
                                   :src="getURL(sasv.octopus_back)"
                                   max-height="300px"
                                   @click="showImage(1)"></v-img>
                          </v-container>
                        </v-input>
                      </v-col>
                    </v-row>
                    <v-row v-if="sasv.id_type === 'PERSONAL_OCTOPUS_AND_STAFF_CARD'">
                      <v-col>
                        <v-input>
                          <v-container fluid class="flex-column pa-0">
                            <legend class="v-label theme--light">{{ $t('admin_sasv.staff_card_front') }}</legend>
                            <v-img contain
                                   :src="getURL(sasv.staff_card_front)"
                                   max-height="300px"
                                   @click="showImage(2)"></v-img>
                          </v-container>
                        </v-input>
                      </v-col>
                      <v-col>
                        <v-input>
                          <v-container fluid class="flex-column pa-0">
                            <legend class="v-label theme--light">{{ $t('admin_sasv.staff_card_back') }}</legend>
                            <v-img contain
                                   :src="getURL(sasv.staff_card_back)"
                                   max-height="300px"
                                   @click="showImage(3)"></v-img>
                          </v-container>
                        </v-input>
                      </v-col>
                    </v-row>

                    <viewer :options="viewerOptions"
                            :images="photos"
                            @inited="onViewerInit">
                      <template slot-scope="{images}">
                        <img v-for="src in images"
                             :key="src"
                             :src="src"
                             style="display: none">
                      </template>
                    </viewer>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_sasv.validated_at')"
                            v-if="sasv.validated_at"
                            :value="$parseDate(sasv.validated_at)"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="sasv.rejected_at">
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_sasv.rejected_at')"
                            :value="$parseDate(sasv.rejected_at)"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="sasv.rejected_at">
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_sasv.reject_reason')"
                            :value="sasv.reject_reason"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field readonly
                            :label="$t('admin_sasv.status')"
                            :value="$t(`sasv_status.${sasv.status}`)"
                            hide-details="auto"></v-text-field>
            </v-col>
          </v-row>
          <v-row v-if="duplicates">
            <v-col>
              <v-expansion-panels accordion>
                <v-expansion-panel>
                  <v-expansion-panel-header>{{ $t('admin_sasv.duplicate_title') }}</v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-data-table multi-sort
                                  :items="duplicates"
                                  :items-per-page="duplicates.length || 1"
                                  :headers="sasvHeaders"
                                  hide-default-footer>
                      <template #item.id_type="{value}">
                        {{ $t(`id_type.${value}`) }}
                      </template>
                      <template #item.validated_at="{value}">
                        {{ value ? $parseDate(value, 'yyyy-MM-dd') : '' }}
                      </template>
                      <template #item.status="{value}">
                        {{ $t(`sasv_status.${value}`) }}
                      </template>
                    </v-data-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
    <template #footer>
      <v-row no-gutters>
        <v-btn @click="cancel"
               class="mr-3"
               depressed
               large>
          {{ $t('cancel') }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               v-if="sasv && sasv.status === 'APPROVED'"
               @click="saveSasv">
          {{ $t('save') }}
        </v-btn>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               v-if="sasv && sasv.status === 'SUSPENDED'"
               key="unsuspend"
               @click="unsuspendSasv">
          {{ $t('admin_sasv.unsuspend') }}
        </v-btn>
        <v-btn color="primary"
               class="ml-4"
               depressed
               large
               v-if="sasv && sasv.status === 'APPROVED'"
               key="suspend"
               @click="suspendSasv">
          {{ $t('admin_sasv.suspend') }}
        </v-btn>
      </v-row>
    </template>
  </BGModal>
</template>
<script>
import {computed, ref, watch} from '@vue/composition-api';
import BGModal from "@/components/BGModal";

export default {
  name: 'EditSasvModal',
  components: {BGModal},
  props: {
    shown: Boolean,
    sasvId: String,
  },
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);

    const dialogShown = ref(props.shown);

    // Init
    watch(() => props.shown, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        dialogShown.value = newValue;

        if (newValue) {
          getSasv();
          getCompanies();
        }
      }
    });
    const cancel = function () {
      emit('cancel');
    };

    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    }

    // Form
    const sasv = ref(null);
    const getSasv = function () {
      root.$callAPI('sasv/admin/', {id: props.sasvId}, function (response) {
        sasv.value = response.body.sasv;
        selectedCompanyId.value = response.body.sasv.company ? response.body.sasv.company.id : null;
        duplicates.value = response.body.duplicates;

        let ph = [];
        [
          'octopus_front',
          'octopus_back',
          'staff_card_front',
          'staff_card_back',
        ].forEach((f) => {
          if (response.body.sasv[f]) {
            ph.push(getURL(response.body.sasv[f]));
          }
        })

        photos.value = ph;
      });
    };

    const selectedCompanyId = ref(null);
    const companies = ref([]);
    const companyOptions = computed(() => {
      return companies.value.map((c) => {
        return {text: c.name_en + ' - ' + c.name_zh, value: c.id};
      })
    });
    const getCompanies = function () {
      root.$callAPI('hkiarace/admin/company/', {
        page_size: -1
      }, function (response) {
        companies.value = response.body.companies;
      });
    };

    const duplicates = ref([]);
    const sasvHeaders = ref([
      {text: root.$t('admin_sasv.octopus_no'), value: 'octopus_no'},
      {text: root.$t('admin_sasv.surname'), value: 'surname'},
      {text: root.$t('admin_sasv.given_name'), value: 'given_name'},
      {text: root.$t('admin_sasv.id_type'), value: 'id_type'},
      {text: root.$t('admin_sasv.company'), value: 'company.name'},
      {text: root.$t('admin_sasv.other_company_name'), value: 'other_company_name'},
      {text: root.$t('admin_sasv.status'), value: 'status', sortable: false},
      {text: root.$t('admin_sasv.validated_at'), value: 'validated_at', boolean: false},

      // {text: '', value: 'actions', sortable: false},
    ]);

    const saveSasv = function () {
      root.$callAPI('sasv/admin/edit/', {
        id: props.sasvId,
        surname: sasv.value.surname,
        given_name: sasv.value.given_name,
        company_id: selectedCompanyId.value,
      }, function (response) {
        emit('finish');
      });
    }
    const suspendSasv = async function () {
      if (confirm(root.$t('admin_sasv.suspend_confirm_msg'))) {
        root.$callAPI('sasv/admin/suspend/', {id: props.sasvId}, function (response) {
          getSasv();
        });
      }
    };
    const unsuspendSasv = async function () {
      if (confirm(root.$t('admin_sasv.unsuspend_confirm_msg'))) {
        root.$callAPI('sasv/admin/unsuspend/', {id: props.sasvId}, function (response) {
          getSasv();
        });
      }
    };

    //
    const photos = ref([]);
    const viewer = ref(null);
    const viewerShown = ref(false);
    const showingImageIdx = ref(null);
    const onViewerInit = function (e) {
      viewer.value = e;
    };
    const viewerOptions = ref({
      inline: false,
      title: false,
      toolbar: {
        prev: {show: true, size: 'large'},
        next: {show: true, size: 'large'},
      },
      rotatable: false,
      zIndex: 303,

      // show(e) {
      //   viewerShown.value = true;
      // },
      // hide(e) {
      //   viewerShown.value = false;
      //   showingImageIdx.value = null;
      // },
      // viewed(e) {
      //   viewerShown.value = true;
      //   showingImageIdx.value = e.detail.index;
      // },
    });

    const showImage = function (index) {
      viewer.value.view(index);
    };

    return {
      requiredRules,

      dialogShown,
      cancel,

      getURL,

      sasv,

      duplicates,
      sasvHeaders,

      selectedCompanyId,
      companyOptions,

      saveSasv,
      suspendSasv,
      unsuspendSasv,

      photos,
      viewerOptions,
      onViewerInit,
      viewerShown,
      showImage,
    }
  },
}
</script>

<style lang="less">
.add-user {

}
</style>
